import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = { class: "modal-footer" }

import { watch, onUnmounted } from 'vue';
  import { iframeCommunication } from '@/utils/iframeCommunication';
  
  
  const __default__ = {
    name: 'BaseModal',
  }
  

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isOpen: { type: Boolean },
    title: {},
    fullScreen: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

  const props = __props
  
  const emit = __emit
  
  const isInIframe = iframeCommunication.isRunningInIframe()
  let savedScrollPosition = 0
  
  // Prevent body scrolling when modal is open
  const preventBodyScroll = () => {
    if (isInIframe) {
      document.body.classList.add('modal-open')
      document.documentElement.classList.add('modal-open')
      return
    }
    savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop
    document.body.style.overflow = 'hidden'
    document.body.style.position = 'fixed'
    document.body.style.top = `-${savedScrollPosition}px`
    document.body.style.width = '100%'
  }
  
  const restoreBodyScroll = () => {
    if (isInIframe) {
      document.body.classList.remove('modal-open')
      document.documentElement.classList.remove('modal-open')
      return
    }
    document.body.style.overflow = ''
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.width = ''
    window.scrollTo({
      top: savedScrollPosition,
      behavior: 'auto'
    })
  }
  
  watch(() => props.isOpen, (isOpen) => {
    if (isOpen) {
      if (isInIframe) {
        iframeCommunication.sendScrollToTop()
      }
      preventBodyScroll()
    } else {
      restoreBodyScroll()
    }
  })
  
  onUnmounted(() => {
    restoreBodyScroll()
  })
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal-fade" }, {
    default: _withCtx(() => [
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["modal-overlay", { 'modal-overlay--fullscreen': _ctx.fullScreen }]),
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (emit('close')), ["self"]))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["modal-box", { 'modal-box--fullscreen': _ctx.fullScreen }])
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.title), 1),
                _createElementVNode("button", {
                  class: "close-button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: "close-button-bottom",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
                }, _toDisplayString(_ctx.$t('common.close')), 1)
              ])
            ], 2)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})